import(/* webpackMode: "eager" */ "/home/runner/work/snapcards/snapcards/src/app/error.tsx");
